/* the key under aichat.main.stages of the live status line, by the latest stage; the server's `message` is never shown */
export const STAGE_MESSAGES: Readonly<Record<string, string>> = {
  thinking: 'thinking',
  composing: 'composing',
  tool_call: 'reading',
  tool_result: 'reading'
}

/* before the first stage, and for a stage the contract does not name */
export const DEFAULT_STAGE_MESSAGE = 'sending'
